import { render, staticRenderFns } from "./SaaSCTA.pug?vue&type=template&id=90c84396&lang=pug&external"
import script from "./SaaSCTA.js?vue&type=script&lang=js&external"
export * from "./SaaSCTA.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports